import { useQuery } from "@tanstack/react-query";
import { useScope } from "@state/scopeContext.lib";
import { getBillingInfo } from "@lib/billing";
import { billingQueryKeys } from "./useBillingStatus";

export function useBillingInfo() {
    const { workspaceId } = useScope();

    return useQuery({
        queryKey: billingQueryKeys.info(),
        queryFn: () => getBillingInfo(workspaceId ?? undefined),
    });
}
